module.exports = __webpack_public_path__ + "static/media/toothbrush.7adda0ca.svg";